<div class="container-fluid mt-2">
  <form [formGroup]="formGroup">
    <div class="row main-panel pt-1">
      <div class="col-12">
        <div class="row">
          <div class="col-12 col-sm-3 d-flex align-items-center">
            <mat-form-field
              class="no-subscript"
              appearance="outline"
              [ngClass]="{
                hilite: isModified('name'),
              }"
            >
              <mat-label>Accelerator Name</mat-label>
              <input
                matInput
                name="acceleratorName"
                (input)="syncAcceleratorName()"
                (change)="setAcceleratorName()"
                formControlName="nameCtrl"
              />
            </mat-form-field>
          </div>
          <div class="col-12 col-sm-2 d-flex align-items-center">
            <mat-form-field
              class="no-subscript"
              appearance="outline"
              [ngClass]="{
                hilite: isModified('description'),
              }"
            >
              <mat-label>Label</mat-label>
              <input
                matInput
                name="acceleratorDescription"
                formControlName="descriptionCtrl"
                (change)="setFormDirty()"
              />
            </mat-form-field>
          </div>
          <div class="col-12 col-sm-2 d-flex align-items-center">
            <div class="slide-center">
              <mat-slide-toggle
                [ngClass]="{
                  hilite: isModified('show'),
                }"
                name="accVisible"
                formControlName="showCtrl"
                (change)="setFormDirty()"
                >Show?</mat-slide-toggle
              >
            </div>
          </div>
          <div class="col-12 col-sm-2 d-flex align-items-center">
            <div class="slide-center">
              <mat-slide-toggle
                [ngClass]="{
                  hilite: isModified('rfSystem'),
                }"
                name="rfSystem"
                formControlName="rfSystemCtrl"
                (change)="setFormDirty()"
                >RF Related?</mat-slide-toggle
              >
            </div>
          </div>
          <div class="col-12 col-sm-2 d-flex align-items-center">
            <div class="slide-center">
              <mat-slide-toggle
                [ngClass]="{
                  hilite: isModified('active'),
                }"
                name="accActive"
                formControlName="activeCtrl"
                (change)="setFormDirty()"
                >Active</mat-slide-toggle
              >
            </div>
          </div>
          <div class="col-12 col-sm-1 pl-3 d-flex align-items-center">
            <button
              class="help-button"
              mat-icon-button
              matSuffix
              color="primary"
              (click)="infoPopup()"
            >
              <mat-icon>help</mat-icon>
            </button>
          </div>
        </div>
        <div class="mb-4">
          <div class="row mb-1">
            <div class="col-12 col-sm-12">
              <mat-label>Restrictions</mat-label>
            </div>
          </div>
          <div
            class="table-container"
            [ngClass]="{
              hilite: isModified('restrictions'),
            }"
          >
            <app-restriction-table
              [isEditionChild]="isEditing || isCreating"
              [restrictionsChild]="restrictionsParent"
              [branchlinesChild]="locationsParent"
              [shutterChild]="accelerator"
              (emitData)="getDataFromRestriction($event)"
            >
            </app-restriction-table>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-sm-12">
            <mat-label>Locations</mat-label>
          </div>
        </div>
        <div
          class="table-container mb-4"
          [ngClass]="{
            hilite: isModified('locations'),
          }"
        >
          <div class="row">
            <div class="col-12 col-sm-12">
              <div class="mat-container">
                <mat-table cdkDropList #table [dataSource]="dataSourceLocation">
                  <ng-container matColumnDef="location">
                    <mat-header-cell *matHeaderCellDef>
                      Location
                    </mat-header-cell>
                    <mat-cell *matCellDef="let element">{{
                      element.name
                    }}</mat-cell>
                  </ng-container>
                  <ng-container matColumnDef="add">
                    <mat-header-cell *matHeaderCellDef>
                      <mat-icon
                        mat-list-icon
                        class="add-icon"
                        (click)="openAddLocationDialog()"
                        >add</mat-icon
                      >
                    </mat-header-cell>
                    <mat-cell *matCellDef="let element">
                      <mat-icon
                        mat-list-icon
                        class="edit"
                        color="accent"
                        (click)="openEditLocationDialog(element)"
                        >edit</mat-icon
                      >
                      <mat-icon
                        mat-list-icon
                        class="delete"
                        color="warn"
                        (click)="deleteLocation(element)"
                        >delete</mat-icon
                      >
                    </mat-cell>
                  </ng-container>
                  <mat-header-row
                    *matHeaderRowDef="getColumns()"
                  ></mat-header-row>
                  <mat-row
                    *matRowDef="let row; columns: getColumns()"
                    [ngClass]="{
                      'added-row': row.isAdded && showModification,
                      'deleted-row': row.isDeleted && showModification,
                      'modified-row':
                        row.isModified &&
                        !row.isAdded &&
                        !row.isDeleted &&
                        showModification,
                    }"
                  ></mat-row>
                </mat-table>
              </div>
            </div>
          </div>
        </div>
        <!-- Keep shielding read-only while a new AC Catalog is being created so RP remains responsible for shielding changes. -->
        <div class="row h-20">
          <div class="col-10">
            <mat-label>Shielding</mat-label>
          </div>
          <div class="col-2">
            <button
              *ngIf="isEditing && !enableMove"
              class="float-right top-20"
              mat-icon-button
              color="primary"
              (click)="enableMove = !enableMove"
              matTooltip="Enable drag and drop"
            >
              <mat-icon>swipe_vertical</mat-icon>
            </button>
            <button
              *ngIf="isEditing && enableMove"
              class="float-right top-20"
              mat-icon-button
              color="warn"
              (click)="enableMove = !enableMove"
              matTooltip="Disable drag and drop"
            >
              <mat-icon>mobiledata_off</mat-icon>
            </button>
          </div>
        </div>
        <div class="row mt-1 mb-4">
          <div class="col-12 col-sm-12">
            <div
              class="table-container"
              [ngClass]="{
                hilite: isModified('shieldings'),
              }"
            >
              <accelerator-shielding
                [accelerator]="accelerator"
                [shieldings]="shieldings"
                [isEditing]="isEditing"
                [showPrev]="showModification"
                [showHistory]="showHistory"
                [enableMove]="enableMove"
                (changed)="shieldingsChanged($event)"
              >
              </accelerator-shielding>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
<div class="no-data" *ngIf="showHistory && acceleratorCatalog?.noDataFound">
  No Detailed data found for this Modification!
</div>
<div id="sidenav-content-buttons" class="sidenav-content-buttons">
  <div class="row no-gutters" *ngIf="!showHistory">
    <div class="col-6">
      <!-- Reset local edit/create state without canceling a submitted pending request. -->
      <button
        mat-stroked-button
        color="warn"
        *ngIf="formGroup.dirty || isEditing || isCreating"
        (click)="cancel()"
      >
        Cancel
      </button>
      <!-- Keep the stronger flat action for canceling submitted pending changes. -->
      <button
        mat-flat-button
        color="warn"
        *ngIf="canCancel && !formGroup.dirty && !isEditing && !isCreating"
        (click)="cancel()"
      >
        Cancel
      </button>
      <button
        mat-flat-button
        color="warn"
        *ngIf="
          canModify &&
          !formGroup.dirty &&
          !isEditing &&
          !isCreating &&
          !acceleratorCatalog?.pendingDetails
        "
        [disabled]="isSharedChildenModified"
        (click)="delete()"
      >
        Delete
      </button>
    </div>
    <div class="col-6 d-flex justify-content-end">
      <span
        class="tooltip-anchor"
        [matTooltip]="pendingSharedChangesRestrictionMessage ?? ''"
        [matTooltipDisabled]="!isSharedChildenModified"
        matTooltipClass="accent-tooltip tooltip-wide"
        matTooltipPosition="above"
      >
        <button
          mat-flat-button
          color="accent"
          class="right-btn"
          *ngIf="
            canModify &&
            !isCreating &&
            !isEditing &&
            acceleratorCatalog?.pendingAcceleratorCatalog?.action != 3
          "
          [disabled]="isSharedChildenModified"
          (click)="modifyAccelerator()"
        >
          Modify
        </button>
      </span>

      <button
        mat-flat-button
        class="ml-2"
        color="primary"
        *ngIf="isEditing || isCreating"
        [disabled]="!isFormDirty()"
        (click)="save()"
      >
        Save
      </button>
      <button
        mat-flat-button
        class="ml-2"
        color="primary"
        class="right-btn"
        *ngIf="canApprove && !isCreating && !isEditing"
        [disabled]="approvalInProgress"
        (click)="approve()"
      >
        <span class="d-flex align-items-center">
          Approve
          <role-chips
            class="ml-2"
            [roleCodes]="'RP'"
            [disabled]="true"
          ></role-chips>
        </span>
      </button>

      <button
        mat-flat-button
        class="ml-2"
        color="warn"
        *ngIf="canApprove && !isCreating && !isEditing"
        (click)="openAddDisapprovalDialog()"
      >
        Disapprove
      </button>
    </div>
  </div>

  <catalog-history-navigation
    *ngIf="showHistory"
    [type]="catalog.AcceleratorCatalog"
    [historyIDs]="acceleratorCatalog?.historyAcceleratorIDs"
    (selectedAcceleratorHistory)="selectedHistory($event)"
  ></catalog-history-navigation>
</div>
